module.exports = __webpack_public_path__ + "img/1513924740.0551e3d9.jpg";